module.exports = __webpack_public_path__ + "static/img/hw_logo.e1b9576.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hw_logo.png
// module id = 8wCI
// module chunks = 38